import {
  ArrayField,
  Datagrid,
  FunctionField,
  RecordContextProvider,
  ReferenceManyField,
  TextField,
  useShowContext,
} from "react-admin";
import type { RaRecord } from "react-admin";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import {
  additionalMembersOnly,
  formatDisplayWhatsappNo,
  isMuttavatteenSabilType,
  type SabilHouseholdMemberInput,
} from "../sabil-household-members";

const ItsFamilyMembers = () => (
  <ReferenceManyField reference="itsdata" target="HOF_ID" source="itsdata.HOF_ID" label={false}>
    <Datagrid
      bulkActionButtons={false}
      rowClick={false}
      empty={
        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
          No ITS family members found in the directory for this HOF.
        </Typography>
      }
    >
      <TextField source="ITS_ID" label="ITS No." />
      <FunctionField
        label="HOF"
        render={(member: RaRecord) =>
          member?.ITS_ID === member?.HOF_ID ? (
            <Chip label="Holder" size="small" color="primary" />
          ) : (
            "—"
          )
        }
      />
      <TextField source="Full_Name" label="Name" />
      <TextField source="Age" label="Age" emptyText="—" />
      <TextField source="Gender" label="Gender" emptyText="—" />
      <TextField source="Mobile" emptyText="—" />
    </Datagrid>
  </ReferenceManyField>
);

const MuttavatteenHouseholdMembers = () => {
  const { record } = useShowContext<RaRecord>();
  const rawMembers = record?.householdMembers;
  const additionalMembers = additionalMembersOnly(
    Array.isArray(rawMembers) ? (rawMembers as SabilHouseholdMemberInput[]) : []
  );

  if (!additionalMembers.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No additional family members yet. Edit this sabil to add members with ITS numbers.
      </Typography>
    );
  }

  const displayRecord = { ...record, householdMembers: additionalMembers };

  return (
    <RecordContextProvider value={displayRecord}>
      <ArrayField source="householdMembers">
        <Datagrid bulkActionButtons={false} rowClick={false}>
          <TextField source="name" label="Name" />
          <TextField source="itsNo" label="ITS" emptyText="—" />
          <FunctionField
            label="WhatsApp"
            render={(member: RaRecord) =>
              formatDisplayWhatsappNo(member?.whatsappNo, { empty: "—" })
            }
          />
        </Datagrid>
      </ArrayField>
    </RecordContextProvider>
  );
};

const FamilyMembers = () => {
  const { record } = useShowContext<RaRecord>();
  if (isMuttavatteenSabilType(record?.sabilType as string | undefined)) {
    return <MuttavatteenHouseholdMembers />;
  }
  return <ItsFamilyMembers />;
};

export default FamilyMembers;
